"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Payment = function Payment(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z",
    fill: props.foregroundColor,
    stroke: props.foregroundColor,
    strokeWidth: "0.5"
  }), _react.default.createElement("path", {
    d: "M13.5006 14.3333H11V12.5H12.5006C12.6332 12.5 12.7604 12.4473 12.8542 12.3536C12.948 12.2598 13.0006 12.1326 13.0006 12C13.0006 11.8674 12.948 11.7402 12.8542 11.6464C12.7604 11.5527 12.6332 11.5 12.5006 11.5H11V11C11.0005 10.6023 11.1586 10.221 11.4398 9.93984C11.721 9.65864 12.1023 9.50046 12.5 9.5H13.5C13.6326 9.5 13.7598 9.44732 13.8536 9.35355C13.9473 9.25979 14 9.13261 14 9C14 8.86739 13.9473 8.74021 13.8536 8.64645C13.7598 8.55268 13.6326 8.5 13.5 8.5H12.4996C11.837 8.50083 11.2018 8.76438 10.7332 9.23287C10.2646 9.70135 10.001 10.3365 10 10.9991V11.5H9.49936C9.36675 11.5 9.23957 11.5527 9.14581 11.6464C9.05204 11.7402 8.99936 11.8674 8.99936 12C8.99936 12.1326 9.05204 12.2598 9.14581 12.3536C9.23957 12.4473 9.36675 12.5 9.49936 12.5H10V14.834C9.99993 14.963 10.0501 15.087 10.1398 15.1798C10.1421 15.1821 10.1441 15.1847 10.1464 15.187C10.1487 15.1893 10.1512 15.1913 10.1536 15.1935C10.2463 15.2833 10.3703 15.3334 10.4994 15.3333H13.5006C13.6332 15.3333 13.7604 15.2807 13.8542 15.1869C13.948 15.0931 14.0006 14.9659 14.0006 14.8333C14.0006 14.7007 13.948 14.5735 13.8542 14.4798C13.7604 14.386 13.6332 14.3333 13.5006 14.3333Z",
    fill: props.foregroundColor
  }));
};

Payment.defaultProps = {
  altText: "Payment",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Payment.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Payment;
exports.default = _default;